// @flow 
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { withHelmet } from 'infrastructure/seo/Helmet';
import ClubAdress from 'components/club/ClubAdress';
import Carousel from 'components/fragments/Carousel/Carousel';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import Breadcrumb from 'components/fragments/Breadcrumb';
import SubMenuHeader from 'components/header/SubMenuHeader';
import PageNotFound from 'components/app/PageNotFound';
import Loading from 'components/fragments/Loading';
import LogeDetailForm from 'components/entreprise/loge/LogeDetailForm';
import { STATUS_LOADING, STATUS_DEFAULT, STATUS_UNKNOWN } from 'constants/statusConstants';
import { dynamicClassName } from 'utils/dynamicClassName';
import { getEntrepriseBreadcrumb } from 'utils/urlUtils';
import { getPlaceholder } from 'utils/assetsUtils';

import type { LogeDetailType } from 'types/LogeDetail';
import type { LogeListType } from 'types/LogeList';
import type { Status } from 'types/Status';
import type { EntrepriseBreadcrumb } from 'types/Settings';

import 'components/entreprise/entreprise.css';

type OwnProps = {
  match: {
    params: {
      matchSlug: string,
      menuSlug: string,
      logeSlug: string,
    }
  }
}
export type DispatchProps = {
  fetchLogeDetail: (slug: string) => void,
  fetchLogeList: () => void,
  displayModal: (content: Object) => void,
  fetchContactForm: () => void,
};

export type StateProps = {
  details: LogeDetailType,
  title: string,
  loges: Array<LogeListType>,
  description: string,
  status: Status,
  breadcrumb_offres_entreprise: Array<EntrepriseBreadcrumb>,
};

type Props = DispatchProps & StateProps & OwnProps;

type State = {
  isSidebarOpen: boolean,
  isVideoVisible: boolean,
};

class LogeDetail extends Component<Props, State> {
  state: State = {
    isSidebarOpen: false,
    isVideoVisible: false,
  };

  componentDidMount() {
    const {
      fetchLogeDetail,
      match: { params: { logeSlug } },
      fetchLogeList,
      fetchContactForm,
    } = this.props;

    fetchLogeDetail(logeSlug);
    fetchLogeList();
    fetchContactForm();
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { logeSlug, menuSlug } }, fetchLogeDetail, fetchLogeList } = this.props;

    if (logeSlug !== prevProps.match.params.logeSlug) {
      fetchLogeDetail(logeSlug);
    }

    if (menuSlug !== prevProps.match.params.menuSlug) {
      fetchLogeList();
    }
  }

  _getBreadcrumbElements = () => {
    const { breadcrumb_offres_entreprise } = this.props;
    return getEntrepriseBreadcrumb(breadcrumb_offres_entreprise);
  }

  _renderHeaderContent = () => {
    const { details: { featured_video : { data }, featured_media: { src }, description }, title } = this.props;

    return (
      <div className="row">
        <div className="col col-md-6 col-lg-7">
          <h1 className="ft-h2">{title}</h1>
          {description && <p className='banner__desc'>{description}</p>}
        </div>
        <div className="col col-md-6 col-lg-5">
          {data.length > 0 && src && (
            <div
              className="video-thumbnail"
              role='button'
              tabIndex={0}
              onClick={() => this._showVideo()}>
              <img src={src} alt={title} />
              <span className="link-icon link-icon--large is-dark">
                <i className="icon icon-play"></i>
              </span>
            </div>
          )}
          {data.length === 0 && src && (
            <div
              className="video-thumbnail">
              <img src={src} alt={title} />
            </div>
          )}
        </div>
      </div>
    );
  }

  _renderSubMenuHeader = () => {
    const {
      status,
      details: { liste_enfants, featured_media: { src } },
      match: { params: { matchSlug, logeSlug } },
    } = this.props;

    const elementBreadcrumb = this._getBreadcrumbElements();

    const subMenus = liste_enfants.map((child, index) => {
      const { title, slug } = child;

      return ({
        menu_order: index,
        object_slug: slug,
        title,
        description: '',
        featured_media: { src },
        texte_cta: '',
        object_id: index,
        type_name: 'endur'
      });
    });

    if (subMenus.length > 0) {
      return (
        <SubMenuHeader
          subMenus={subMenus}
          subMenuPath={`${elementBreadcrumb[elementBreadcrumb.length - 1].to}/hospitalites/${matchSlug}/${logeSlug}`}
          status={status}
          niveauMenu={7} />
      );
    }

    return null;
  }

  _renderHeader = () => {
    const {
      title,
      match: { params: { matchSlug } },
      details: { tags_list, featured_media: { src } },
    } = this.props;
    let name = '';

    if (tags_list && tags_list[0]) {
      name = tags_list[0].name;
    }

    const elementBreadcrumb = this._getBreadcrumbElements();

    return (
      <section className="banner banner--lounge">
        <div
          className="banner__thumbnail img-blue-dark"
          style={{ backgroundImage: `url(${src})` }}/>
        <div className="container">
          <Breadcrumb
            elements={[
              { name: 'accueil', to: '/' },
              ...elementBreadcrumb,
              {
                name,
                to: `${elementBreadcrumb[elementBreadcrumb.length - 1].to}/hospitalites/${matchSlug}`,
              },
              title
            ]}
            isDark
          />
          {this._renderHeaderContent()}
          {this._renderSubMenuHeader()}
        </div>
      </section>
    );
  }

  _renderFooter = () => {
    const { loges, match: { params: { logeSlug } } } = this.props;
    const logesFiltered = loges.filter((loge) => loge.slug !== logeSlug);

    if (logesFiltered && logesFiltered.length > 0) {
      return (
        <div className="section container">
          <div className="row">
            <div className="col">
              <p className="ft-h2 mb-3">Autres offres loges et salons</p>
              <Carousel
                list={logesFiltered}
                renderItems={this._renderCarouselItem}
                />
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  _renderMap = () => {
    const { details: { liste_enfants }, match: { params: { menuSlug } } } = this.props;
    const content = liste_enfants.filter((child) => child.slug === menuSlug);

    if (content && content.length > 0 && content[0].leaflet_map) {

      const mapData = content[0].leaflet_map;

      if (mapData) {
        const lat = mapData.lat;
        const long = mapData.long;
        const address = mapData.adress;
        const name = mapData.name;

        if (!lat || !long) {
          return null;
        }

        return (
          <ClubAdress
            name={name}
            adress={address}
            lat={lat}
            long={long}
            />
        );
      }
      
      return null;
    }

    return null;
  }

  _renderCarouselItem = (loge: LogeListType): any => {
    const { title, featured_media: { src: image }, prix_base, link, slug } = loge;
    let src = image;

    if (image === '') {
      src = getPlaceholder();
    }

    return (
      <Link
        to={link}
        title={title}
        key={slug}
        className="box box--white card card--ticket card--offer card--small ">
        <div className="card__header">
          <div
            className="card__thumbnail"
            style={{ backgroundImage: `url('${src}')` }}
            >
            {image !== '' && <img src={src} alt={`Illustration de l'offre ${title}`} />}
          </div>
        </div>
        <div className="card__body">
          <h3 className="mb-2">{title}</h3>
        </div>
        <div className="card__footer">
          <div className="card--offer__price">
            <p className="ft-700 ft-up ft-tertiary ft-black-tertiary mb-0">À partir de</p>
            <p className="ft-h3 ft-300 ft-expo mb-0">{prix_base} HT <span>/pers.</span></p>
          </div>
        </div>
      </Link>
    );
  }

  _renderContent = () => {
    const { details: { liste_enfants }, match: { params: { menuSlug } } } = this.props;
    const content = liste_enfants.filter((child) => child.slug === menuSlug);

    if (content && content[0] && content[0].content) {
      return content[0].content.data.map((contentData, index) => (<ContentBloc key={index} {...contentData} />));
    }

    if (!menuSlug && liste_enfants[0] && liste_enfants[0].content) {
      return liste_enfants[0]
        .content.data.map((contentData, index) => (<ContentBloc key={index} {...contentData} />));
    }

    return null;
  }

  _renderHeaderVideo = () => {
    const { details: { featured_video: { data } } } = this.props;

    if (data.length > 0) {
      return data
        .map((video, index) => <ContentBloc key={index} {...video} />);
    }

    return null;
  }

  onSubmitLogeDetailForm = (content: Object) => {
    const { displayModal } = this.props;
    const { isSidebarOpen } = this.state;

    this.setState({ isSidebarOpen: !isSidebarOpen }, () => displayModal(content));
  }

  _renderSidebar = () => {
    const { isSidebarOpen } = this.state;
    const { details } = this.props;
    const classNames = dynamicClassName('sidebar sidebar--form col col-lg-4');
    !isSidebarOpen && classNames.add('is-hidden');

    return (
      <div className={classNames.build()}>
        <div className='box box--white estimation mt-lg-2'>
            <h3
              className='ft-400 box--content separator'
              onClick={() => this.setState({ isSidebarOpen: !isSidebarOpen })}
              role='button'
              tabIndex={0} >
              Estimer la prestation
            </h3>
            <LogeDetailForm loge={details} onSubmit={this.onSubmitLogeDetailForm} />
        </div>
      </div>
    );
  }
  
  _hideVideo = () => {
    document.getElementsByTagName("iframe")[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    this.setState({ isVideoVisible: false });
  }

  _showVideo = () => {
    document.getElementsByTagName("iframe")[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    this.setState({ isVideoVisible: true });
  }

  render() {
    const { status, details: { prix_base, title } } = this.props;
    const { isVideoVisible } = this.state;

    if (status === STATUS_LOADING || status === STATUS_DEFAULT) {
      return <Loading isBlue  backgroundColor={'#013974'} />;
    }

    if (status === STATUS_UNKNOWN) {
      return <PageNotFound noMargin />;
    }

    const videoClassname = dynamicClassName('video-player');
    isVideoVisible && videoClassname.add('is-visible');

    return (
      <>
        {this._renderHeader()}
        <div className="section-white">
          <div className="container">
            <div className="row">
              <div className="col col-lg-8 page page--full">
                {this._renderMap()}
                {this._renderContent()}
              </div>
              {prix_base > 0 && this._renderSidebar()}
            </div>
          </div>
        </div>
        {this._renderFooter()}
        <div className={videoClassname.build()}>
          <div
            className="video-player-top"
            role='button'
            tabIndex={0}
            onClick={() => this._hideVideo()}>
            <i className="icon icon-close"></i>
          <div
            className="link-chevron link-chevron--white link-chevron--left">
            <span>Retour au {title}</span>
            <i className="icon icon-chevron-left"></i>
          </div>
        </div>
          <div className="video-player__wrapper">
            {this._renderHeaderVideo()}
          </div>
        </div>
      </>
    );
  }
}

export default withHelmet(LogeDetail)((Helmet, pageProps) => {
  const { meta_title, meta_description, details: { featured_media : { src, title } } } = pageProps;

  return (
    <Helmet>
      <title>{meta_title}</title>
      <meta name={'description'} content={meta_description} />
      <meta property={'og:title'} content={meta_title} />
      <meta property={'og:description'} content={meta_description} />
      <meta property={'og:image'} content={src} />
      <meta property={'og:image:url'} content={src} />
      <meta property={'og:image:title'} content={title} />
    </Helmet>
  );
});
